module.exports = __webpack_public_path__ + "images/main_kid.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main_kid.png
// module id = 1124
// module chunks = 0